import React, {useEffect} from 'react';
import {formatPrice} from 'shared/helpers';
import {TableRow, TableCell} from './VariationCostMoreInfo';
import {useLazyGetExtraVariationsQuery} from 'components/customer/Job/store/jobApi';

const JobExtraVariationCostMoreInfo = ({jobId}: {jobId: number}) => {
    const [getExtraVariations, {data: extraVariationList}] =
        useLazyGetExtraVariationsQuery();

    useEffect(() => {
        if (jobId) {
            void getExtraVariations({jobId: jobId}, true);
        }
    }, [jobId]);

    return extraVariationList && extraVariationList.length > 0 ? (
        <>
            {extraVariationList.map((item) => {
                const isAppliance =
                    item.job_cabinet_appliance_id != null &&
                    item.job_cabinet_appliance_id > 0;

                return (
                    <TableRow key={item.id}>
                        <TableCell>
                            <strong>
                                {isAppliance && item.product_label
                                    ? item.product_label
                                    : 'Custom Variations:'}
                            </strong>
                        </TableCell>
                        <TableCell style={{color: 'rgb(255, 0, 0)'}}>
                            {isAppliance && item.detail_label
                                ? item.detail_label
                                : item.name}
                        </TableCell>
                        <TableCell $align="right">
                            {formatPrice(item.cost, {})}
                        </TableCell>
                    </TableRow>
                );
            })}
        </>
    ) : null;
};

export default JobExtraVariationCostMoreInfo;
